import Topbar from "../../components/Topbar";
import { useFinanceiro } from "./hooks/useFinanceiro";
import CalendarioFinanceiro from "./components/CalendarioFinanceiro";
import CardsResumo from "./components/CardsResumo";
import FluxoCaixa from "./components/FluxoCaixa";
import TabelaContas from "./components/TabelaContas";
import ModalConta from "./components/ModalConta";
import ModalPagar from "./components/ModalPagar";

export default function Financeiro() {
  const f = useFinanceiro();

  return(
    <>
      <Topbar title="Financeiro"/>
      <div className="erp-content">
        <CardsResumo contasPagar={f.contasPagar} contasReceber={f.contasReceber} fluxo={f.fluxo}/>
        <FluxoCaixa fluxo={f.fluxo} mes={f.mes} setMes={f.setMes} ano={f.ano} setAno={f.setAno}/>

        <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap"}}>
          {[["pagar","Contas a Pagar"],["receber","Contas a Receber"]].map(([k,l])=>(
            <button key={k} className={"btn btn-secondary"+(f.aba===k&&f.abaVis==="lista"?" aba-ativa":"")}
              onClick={()=>{f.setAba(k);f.setAbaVis("lista");f.setFiltroStatus("");}}>
              {l}
            </button>
          ))}
          <button className={"btn btn-secondary"+(f.abaVis==="calendario"?" aba-ativa":"")} onClick={()=>f.setAbaVis("calendario")}>
            <i className="ti ti-calendar"/> Calendario
          </button>
        </div>

        {f.abaVis==="calendario" && <CalendarioFinanceiro contasPagar={f.contasPagar} contasReceber={f.contasReceber}/>}

        {f.abaVis==="lista" && (
          <TabelaContas
            aba={f.aba} abrirNovo={f.abrirNovo} STATUS={f.STATUS} lista={f.lista}
            filtroStatus={f.filtroStatus} setFiltroStatus={f.setFiltroStatus}
            loading={f.loading} filtrada={f.filtrada} totalPendente={f.totalPendente} totalVencido={f.totalVencido}
            setModalPagar={f.setModalPagar} setDataPag={f.setDataPag}
            setForm={f.setForm} setModalForm={f.setModalForm} excluir={f.excluir}
          />
        )}
      </div>

      <ModalConta
        aba={f.aba} modalForm={f.modalForm} form={f.form} setF={f.setF} salvando={f.salvando}
        salvarConta={f.salvarConta} onFechar={()=>f.setModalForm(null)}
        STATUS={f.STATUS} clientes={f.clientes} fornecedores={f.fornecedores}
      />

      <ModalPagar
        aba={f.aba} modalPagar={f.modalPagar} dataPag={f.dataPag} setDataPag={f.setDataPag}
        confirmarPagamento={f.confirmarPagamento} onFechar={()=>f.setModalPagar(null)}
      />
    </>
  );
}
